import React, { useState } from "react";
import PropTypes from "prop-types";

import { Formik, Form } from "formik";

import Title from "./CardSearchTable/Title";
import Search from "./CardSearchTable/Search";
import Table from "./CardSearchTable/Table";
import LoadMore from "./CardSearchTable/LoadMore";

export default function CardSearchTable({
  children = [],
  columns = [],
  empty = "No records match your search.",
  header,
  tooltip,
  placeholder = "",
  searchName = "search",
  onSubmit = (x) => {},
  onLoadMore = (x) => {},
  page = { records: 0, initial: 0, current: 0 },
}) {
  const handleSort = (e) => console.log(e);
  const initialValues = { [searchName]: "" };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => onSubmit(values)}
    >
      <Form>
        <div className="row">
          <div className="col m12 l12">
            <div className="card-panel">
              <Title header={header} tooltip={tooltip} />
              <Search placeholder={placeholder} name={searchName} />
              <Table columns={columns} empty={empty} rows={children} />
              <LoadMore page={page} onLoadMore={onLoadMore} />
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
}

CardSearchTable.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.array, // @TODO be more specific [string or fn]
  empty: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  header: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  searchName: PropTypes.string,
  onSubmit: PropTypes.func,
  onLoadMore: PropTypes.func,
  page: PropTypes.shape({
    records: PropTypes.number,
    current: PropTypes.number,
    initial: PropTypes.number,
  }),
};
